import { apostleTicketSchema as t } from "../yup/apostle.js";
import { useCallback as a } from "react";
const s = () => ({
  makeApostleTicket: a((e) => t.validateSync(e), [])
});
export {
  s as default
};
//# sourceMappingURL=useMakeApostleTicket.js.map
